// extracted by mini-css-extract-plugin
export default {"checkbox":"ConfirmAccount_checkbox__pQJ8t","skeletonLoadingAnimation":"ConfirmAccount_skeletonLoadingAnimation__PiPLE"};